
const ProgramsPage = () => {
  const programs = [
    { icon: '🦕', title: 'Erken Eğitim', desc: 'Daha iyi okul öncesi okuma becerileri, zengin kelime dağarcığı', age: '2-4 Yaş', color: 'from-pink-400 to-pink-600' },
    { icon: '🦖', title: 'ABC Programı', desc: 'Daha iyi okul öncesi okuma becerileri, zengin kelime dağarcığı', age: '4-6 Yaş', color: 'from-blue-400 to-blue-600' },
    { icon: '🦕', title: 'İlk Adımlar 4K', desc: 'Daha iyi okul öncesi okuma becerileri, zengin kelime dağarcığı', age: '6-8 Yaş', color: 'from-yellow-400 to-yellow-600' }
  ];

  return (
    <div className="min-h-screen pt-24">
      <section className="relative py-20 bg-gradient-to-br from-yellow-100 via-blue-100 to-pink-100">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block px-6 py-2 bg-gradient-to-r from-blue-500 to-green-500 text-white rounded-full text-sm font-bold uppercase tracking-wide mb-6">
            Eğitim Programlarımız
          </span>
          <h1 className="text-6xl font-black text-gray-900 mb-6">
            Eğitim <span className="bg-gradient-to-r from-pink-500 to-orange-500 bg-clip-text text-transparent">Programlarımızı</span> Keşfedin
          </h1>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-10">
            {programs.map((program, index) => (
              <div key={index} className={`bg-gradient-to-br ${program.color} p-12 rounded-[40px] text-center shadow-2xl hover:scale-105 hover:-rotate-1 transition-all`}>
                <div className="text-8xl mb-6 animate-bounce">{program.icon}</div>
                <h3 className="text-3xl font-black text-white mb-4">{program.title}</h3>
                <p className="text-white/95 text-lg mb-6 leading-relaxed">{program.desc}</p>
                <div className="inline-block px-6 py-2 bg-white rounded-full font-bold mb-6">{program.age}</div>
                <button className="w-full py-3 bg-white text-gray-900 rounded-full font-bold hover:scale-105 transition-all shadow-lg">
                  Daha Fazla →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-black text-center text-gray-900 mb-12">
            Ana Çocuk <span className="bg-gradient-to-r from-pink-500 to-orange-500 bg-clip-text text-transparent">Aktivitelerimiz</span>
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { icon: '🎮', title: 'Outdoor Games' },
              { icon: '⚽', title: 'Sport Activites' },
              { icon: '🎲', title: 'Table/Floor Toys' },
              { icon: '💧', title: 'Water Games' }
            ].map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg flex items-center gap-4 hover:translate-x-2 transition-all">
                <span className="text-5xl">{item.icon}</span>
                <span className="text-xl font-bold text-gray-900">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProgramsPage;